/**
* External Dependencies
*/

import 'jquery';
import Swiper from 'swiper/bundle';

var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
import * as basicScroll from 'basicscroll';

import Plyr from 'plyr';

$(document).ready(function() {

  const players = Array.from(document.querySelectorAll('.plyr__video-embed'));

  players.map(player => new Plyr(player, {
    ratio: '16:9',
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
    autopause: false,
    muted: false,
  }));

  document.addEventListener( 'wpcf7mailsent', function( event ) {
    location = '/bedankt/';
  }, false );

  document.querySelectorAll('.scroll-scale').forEach((elem) => {
    basicScroll.create({
      elem: elem,
      from: 'top-middle',
      to: 'middle-middle',
      direct: true,
      props: {
        '--tw-scale-x': {
          from: '1',
          to: '1.1',
        },
        '--tw-scale-y': {
          from: '1',
          to: '1.1',
        }
      },
    }).start()
  });

  document.querySelectorAll('.scroll-translate-y').forEach((elem) => {
    basicScroll.create({
      elem: elem,
      from: 'top-top',
      to: 'bottom-bottom',
      direct: true,
      props: {
        '--tw-translate-y': {
          from: '0',
          to: '4rem',
        }
      },
    }).start()
  });

  document.querySelectorAll('.-scroll-translate-y').forEach((elem) => {
    basicScroll.create({
      elem: elem,
      from: 'top-top',
      to: 'bottom-bottom',
      direct: true,
      props: {
        '--tw-translate-y': {
          from: '0',
          to: '-3rem',
        }
      },
    }).start()
  });

  var Swipes = new Swiper('.swiper-container', {
    loop: true,
    centeredSlides: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 16
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 24
      },
      // when window width is >= 480px
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 24
      },
    },
    parallax: true,
    preloadImages: true,
    navigation: {
      prevEl: '.slidePrev-btn',
      nextEl: '.slideNext-btn'
    }
  });

  // SCROLLED
  $(window).on('load scroll', function() {
    if ($(window).scrollTop() > 0) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  });

  // MENU
  $('.hamburger').click(function() {
    $(this).toggleClass('active');
    $('body').toggleClass('hamburger-active');
    $('html').toggleClass('overflow-hidden');
  });

  $('.close-nav').click(function() {
    $('.hamburger').toggleClass('active');
    $('body').toggleClass('hamburger-active');
    $('html').toggleClass('overflow-hidden');
  });

  // News
  $('.news-checkbox').change(handleCatFilter);

  function handleCatFilter () {

    var uristring = '?category=';

    $('.news-checkbox:checked').each(function(index) {
      var isLastElement = index == $('.news-checkbox:checked').length -1;

      uristring += $(this).val();

      if(!isLastElement) {
        uristring += ',';
      }

    });

    window.location.href = uristring;
  }
});
